import React, { useState, useEffect } from "react";
import AsignacionObras from "./asignacionObras";
import CaratulaContrato from "./caratulaContrato";
import { Mensaje } from "../mensajes2";

import { Dimmer } from "../spinner";

import useTable from "../useTable3";
import axios from "axios";
import { Toasts } from "../toasts";
import { SearchInput } from "../../ui/inputs/Input";
import { PrimaryButton } from "../../ui/buttons/Button";
import { formatMoneda } from "../../util/varios";


function TablaObras(props) {
    let token = localStorage.getItem("jwtToken");
    let op = require("../../../src/modulos/datos");
    const anioactu = JSON.parse(localStorage.getItem("anioactu"));
    const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));

    const [titulo, setTitulo] = useState();
    const [index, setIndex] = useState()
    const [msg, setMsg] = useState();
    const [titulo1, setTitulo1] = useState();
    const [msg1, setMsg1] = useState();
    const [mostrar, setMostrar] = useState(false);
    const [mostrar5, setMostrar5] = useState(false);
    const [idObra, setIdObra] = useState(0);
    const [activate, setActivate] = useState(false);
    const [operacion, setOperacion] = useState(0);
    const [obra, setObra] = useState();
    const [cuentas, setCuentas] = useState();
    const [statusCome, setStatusCome] = useState();
    const [configCome, setConfigCome] = useState();
    const [idUsuario, setIdUsuario] = useState();
    const [deuda, setDeuda] = useState();
    const [historico, setHistorico] = useState();
    const [pagow, setPagow] = useState();
    const [retencion, setRetencion] = useState();
    const [multas, setMultas] = useState();
    const [mensaje, setMensaje] = useState({
        mostrar: false,
        titulo: "",
        texto: "",
        icono: "",
    });
    const [facturasPagadas, setFacturasPagadas] = useState();
    const [facturasPagadasEtax, setFacturasPagadasEtax] = useState();

    const [facturasOtrosPgosEtax, setFacturasOtrosPgosEtax] = useState();

    const [factorCambio, setFactorCambio] = useState(0);

    const [espiritu, setEspiritu] = useState(localStorage.getItem("espiritu"));
    const [fechaSistema, setFechaSistema] = useState(
        localStorage.getItem("fechasistema")
    );
    const [anioActu, setAnioActu] = useState(localStorage.getItem("anioactu"));
    const [deshabilitado, setDeshabilitado] = useState(false);
    const permiso = JSON.parse(localStorage.getItem("acccontribuyente"));
    const [permisoDecla, setPermisoDecla] = useState();
    const [permisoExon, setPermisoExon] = useState();
    const [records, setRecords] = useState([]);
    const [sigue, setSigue] = useState(false);
    const [toast, setToast] = useState({
        mostrar: false,
        mensaje: "",
        titulo: "",
    });

    const [filterFn, setFilterFn] = useState({
        fn: (items) => {
            return items;
        },
    });

    const headCells = [
        {
            id: "idobraasignada",
            backgroundColor: "rgba(5, 81, 130, 1)",
            color: "#ffffff",
            label: "Nº ASIGNACION",
            textAlign: "center",
            width: "80px",
        },
        {
            id: "descripcionobra",
            backgroundColor: "rgba(5, 81, 130, 1)",
            color: "#ffffff",
            label: "DESCRIPCION",
            textAlign: "center",
            width: "350px",
        },
        {
            id: "razonsocial",
            backgroundColor: "rgba(5, 81, 130, 1)",
            color: "#ffffff",
            label: "EMPRESA ASIGNADA",
            textAlign: "center",
            width: "80px",
        },
        {
            id: "opciones",
            backgroundColor: "rgba(5, 81, 130, 1)",
            color: "#ffffff",
            label: " OPCIONES",
            textAlign: "center",

        },
    ];

    const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
        useTable(records, headCells, filterFn);

    const handleSearch = (e) => {
        let target = e.target;

        setFilterFn({
            fn: (items) => {
                if (target.value === "") {
                    return items;
                } else {
                    return items.filter((x) => {
                        if (
                            (x.idobraasignada.includes(target.value) === null
                                ? ""
                                : x.idobraasignada.includes(target.value)) ||
                            (x.descripcionobra === null
                                ? ""
                                : x.descripcionobra.toLowerCase().includes(target.value.toLowerCase())) ||
                            (x.razonsocial === null
                                ? ""
                                : x.razonsocial.toLowerCase().includes(target.value.toLowerCase()))
                        ) {
                            return x;
                        }
                    });
                }
            },
        });
    };

    const seleccionarObras = () => {
        setActivate(true);
        setRecords([]);
        let compro = 0;
        let endpoint = `${op.conexion}/api/ingenieria/seleccionarobrasasignadas?idefiscal=${idefiscal}&compro=${compro}`;
        //let endpoint = `${op.conexion}/api/industria/comercios`;

        axios
            .get(endpoint, {
                headers: {
                    "x-access-token": `${token}`,
                    'Content-Type': 'application/json'

                },
            })
            .then((response) => {
                if (response.status == 200) {
                    if (response.data.length > 0) {
                        setRecords(response.data);
                        console.log(response.data);
                    }
                }

                setActivate(false);
            })
            .catch((error) => {
                setMensaje({
                    mostrar: true,
                    titulo: "ERROR",
                    texto: error.response.data.message,
                    icono: "error",
                });
                console.log(error)
                setActivate(false);
            });
    };
    
    const SelectObra = (idobra, index) => {
        //alert(idobra)
        let endpoint = `${op.conexion}/api/ingenieria/seleccionarobraasignada/${index.idobraasignada}`;

        axios
            .get(endpoint, {
                headers: {
                    "x-access-token": `${token}`,
                    'Content-Type': 'application/json'

                },
            })
            .then((response) => {
                if (response.status == 200) {
                    setCuentas(response.data);
                    setMostrar(true);
                }
                setActivate(false)
            })
            .catch((error) => {
                setMensaje({
                   mostrar: true,
                   titulo: "ERROR",
                   texto: error.response.data.message,
                   icono: "error",
                 }); 
                console.log(error)
            });
    };
    
    const agregarObra = (permiso) => (e) => {
        e.preventDefault();
        if (permiso === "1") {
            setOperacion(1);
            setObra();
            setDeshabilitado(false);
            setMostrar5(true);
        } else {
            setToast({
                mostrar: true,
                titulo: "Notificación",
                mensaje:
                    "No posee permiso para registrar una Obra",
            });
        }
    };

    const cerrarModalActualizar = () => {
        setObra();
        if (props.tipo === "obras"){
            setMostrar5(false);
        } else {
            setMostrar(false);
            setCuentas();
        }
        
        seleccionarObras();
    };

    const validarActuComercio = () => {
        if (operacion === 4) {
            setObra();
            setMostrar5(false);
            return;
        }
        if (operacion === 1) {
            setIdObra(0);
        }

        setObra();
        setMostrar5(false);
        renderizar();
    };

    const handleCloseMensa = () => {
        setMostrar(false);
    };

    const renderizar = () => {
        seleccionarObras();
    };

    const gestionarObra = (ope, id, index, permiso) => (event) => {
        event.preventDefault();
        //setIndex(index.rif)
        if (permiso === "1") {
            setObra(index);
            setDeshabilitado(true);
            setIdObra(id);
            //setActivate(true);
            //SelectObra(id, index);
            setOperacion(ope);
            if (props.tipo === "obras"){
                setMostrar5(true);
            } else {
                SelectObra(id, index);
                //setMostrar(true);
            }
            
        } else {
            setToast({
                mostrar: true,
                titulo: "Notificación",
                mensaje:
                    "No posee permiso para consultar una Obra",
            });
        }
    };

    const consultarObra = (id, index, permiso) => (event) => {
        event.preventDefault();
        //setIndex(index.rif)
        if (permiso === "1") {
            setDeshabilitado(true);
            setIdObra(id);
            setActivate(true);
            SelectObra(id, index);
            setOperacion(4);
            //setMostrar5(true);
        } else {
            setToast({
                mostrar: true,
                titulo: "Notificación",
                mensaje:
                    "No posee permiso para consultar una Obra",
            });
        }
    };

    const editarObra = (id, index, permiso) => (event) => {
        event.preventDefault();
        //setIndex(index.rif)

        if (permiso === "1") {
            setOperacion(2);
            setDeshabilitado(false);
            setIdObra(id);
            setActivate(true);
            SelectObra(id, index);
        } else {
            setToast({
                mostrar: true,
                titulo: "Notificación",
                mensaje:
                    "No posee permiso para editar una Obra",
            });
        }
    };

    const eliminarObra = (id, index, permiso) => (event) => {
        event.preventDefault();
        //setIndex(index.rif)
        if (permiso === "1") {
            setOperacion(3);
            setDeshabilitado(true);
            setIdObra(id);
            setActivate(true);
            SelectObra(id, index);

        } else {
            setToast({
                mostrar: true,
                titulo: "Notificación",
                mensaje:
                    "No posee permiso para eliminar una Obra",
            });
        }
    };

    const seleccionarFactorCambio = () => {
        let endpoint = `${op.conexion}/api/vehiculo/factorcambio`;
        setActivate(true);

        axios
            .get(endpoint, {
                headers: {
                    "x-access-token": `${token}`,
                    'Content-Type': 'application/json'

                },
            })
            .then(function (response) {
                if (response.status == 200) {
                    setFactorCambio(response.data.valor);
                }
            })
            .catch(function (error) {
                /*  setMensaje({
                   mostrar: true,
                   titulo: "ERROR",
                   texto: error.response.data.message,
                   icono: "error",
                 }); */
                console.log(error)
            });
    };

    useEffect(() => {
        let obj = JSON.parse(localStorage.getItem("post"));

        seleccionarFactorCambio();
        setPermisoDecla(JSON.parse(localStorage.getItem("permisos")).accpermdecla);
        setPermisoExon(
            JSON.parse(localStorage.getItem("permisos")).accexoncomercio
        );
        setFechaSistema(obj.fechasistema);
        setIdUsuario(obj.idusuario);
        setEspiritu(obj.espiritu);

        seleccionarObras();
    }, []);

    useEffect(() => {
        
    }, [cuentas]);

    const cerrarToast = () => {
        setToast({
            ...toast,
            mostrar: false,
        });
    };

    const cerrar = () => {
        props.setTabla(0);
    };

    return (
        <div className="col-10 mx-auto m-0 p-2 border rounded">

            <div className="col-12 m-0 my-2 p-0 d-flex justify-content-between">
                <div className="col-3 m-0 p-0">
                    <SearchInput
                        onChange={handleSearch}
                        placeholder="Buscar"
                    />
                </div>
                {props.tipo === "obras" ?
                    <div className="col-auto m-0 p-0">
                        <PrimaryButton icon='fa-plus m-0'
                            onClick={agregarObra(
                                permiso.toString().substring(1, 2)
                            )}
                            disabled={permiso.toString().substring(1, 2) !== "1"}
                        >
                        </PrimaryButton>
                    </div>
                : ""}
            </div>
            <div className="col-12 m-0 p-0" >
                <TblContainer >
                    <TblHead />
                    <tbody  >
                        {records &&
                            recordsAfterPagingAndSorting().map((item, index) => (
                                <tr
                                    key={item.idobraasignada}
                                    style={{ padding: "0" }}
                                >
                                    <td
                                        className="align-baseline"
                                        style={{
                                            textAlign: "center",
                                            width: "80px",
                                        }}
                                    >
                                        {item.idobraasignada}
                                    </td>
                                    <td
                                        className="align-baseline"
                                        style={{
                                            textAlign: "center",
                                            width: "350px",
                                        }}
                                    >
                                        {item.descripcionobra}
                                    </td>
                                    <td
                                        className="align-baseline"
                                        style={{
                                            textAlign: "center",
                                            width: "80px",
                                        }}

                                    >
                                        {item.razonsocial}
                                    </td>
                                    <td
                                        className="align-baseline text-center"
                                        style={{ width: '150px' }}


                                    >
                                        <button
                                            onClick={gestionarObra(
                                                4,
                                                item.idobra,
                                                item,
                                                permiso.toString().substring(0, 1)
                                            )}
                                            title="Consultar Contribuyente"
                                            className={
                                                permiso.toString().substring(0, 1) === "1"
                                                    ? "btn btn-sm btn-info rounded-pill"
                                                    : "btn btn-sm btn-secondary rounded-pill"
                                            }
                                        >
                                            <i className="fas fa-eye"></i>
                                        </button>
                                        <a> &nbsp; </a>
                                        <button
                                            onClick={gestionarObra(
                                                2,
                                                item.idobra,
                                                item,
                                                permiso.toString().substring(2, 3)
                                            )}
                                            title="Editar Con"
                                            className={
                                                permiso.toString().substring(2, 3) === "1"
                                                    ? "btn btn-sm btn-warning rounded-pill"
                                                    : "btn btn-sm btn-secondary rounded-pill"
                                            }
                                        >
                                            <i className="fa fa-edit"></i>
                                        </button>
                                        <a> &nbsp; </a>
                                        {props.tipo === "obras" ?
                                            <button
                                                onClick={gestionarObra(
                                                    3,
                                                    item.idobra,
                                                    item,
                                                    permiso.toString().substring(3, 4)
                                                )}
                                                className={
                                                    permiso.toString().substring(3, 4) === "1"
                                                        ? "btn btn-sm btn-danger rounded-pill"
                                                        : "btn btn-sm btn-secondary rounded-pill"
                                                }
                                            >
                                                <i className="fa fa-trash-alt"></i>
                                            </button>
                                       : ""}
                                    </td>
                                </tr>
                            ))}
                    </tbody>
                </TblContainer>
                <TblPagination />
            </div>
            <AsignacionObras
                show={mostrar5}
                factorCambio={factorCambio}
                onHideCancela={cerrarModalActualizar}
                onHideAcepta={validarActuComercio}
                obra={obra}
                operacion={operacion}

            />
            <CaratulaContrato
                show={mostrar}
                factorCambio={factorCambio}
                onHideCancela={cerrarModalActualizar}
                onHideAcepta={validarActuComercio}
                obra={obra}
                cuentas={cuentas}
                operacion={operacion}
                deshabilitado={operacion === 3 || operacion === 4 ? true : false}

            />
            <Mensaje
                mensaje={mensaje}
                onHide={() => {
                    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
                }}
            />
            <Dimmer active={activate} inverted>
            </Dimmer>
            <Toasts
                show={toast.mostrar}
                titulo={toast.titulo}
                mensaje={toast.mensaje}
                onHideCancela={cerrarToast}
            />
        </div>
    );
}

export default TablaObras;
